import Logo from '../../shared/Logo/Logo';
import CartSideBar from '../cart/CartSideBar';
import MenuBar from './MenuBar';

const MainNav = () => {

  return (
    <>
      <div className="container flex items-center justify-between py-4">
        <div className="flex-1 lg:hidden mt-4">
          <MenuBar />
        </div>
        <div className="flex items-center gap-5 lg:basis-[60%] mt-4">
          <Logo />
        </div>
        <div className="flex flex-1 items-center justify-end gap-5 mt-4">
          <div className="flex items-center divide-x divide-neutral-300">
            <CartSideBar />
          </div>
        </div>
      </div >
      <div className="lg:hidden flex justify-center mt-4" style={{ color: "rgb(0 110 186)" }}>
        <p className="mx-auto w-1/2 bg-white p-2 font-bold border rounded-lg" style={{ color: "rgb(0 110 186)" }}>
          📦 Envío gratis a partir de los $160000!
        </p>
      </div>



    </>
  );
};

export default MainNav;
